module.exports = __webpack_public_path__ + "static/media/icon-move.f2b872ea.png";